import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import Button from 'presentations/views/components/atoms/Button';
import Rating from 'presentations/views/components/atoms/Rating';
import { onboardPath, signUpPath, webPath } from 'presentations/routes/path';
import { useRouter } from 'next/router';
import { white } from 'presentations/views/styles/color';

export default function Component() {
  const t = translateInComponent(translations);
  const router = useRouter();
  const reviewLink =
    router.locale === 'ja'
      ? 'https://www.capterra.jp/reviews/1025834/jicoo'
      : 'https://www.capterra.com/reviews/247184/Jicoo';
  return (
    <>
      <SectionTitle title={t('title')} description={t('description')} />
      <Badge>
        <a href={reviewLink}>
          <img
            src="https://assets.capterra.com/badge/ca0b505fd4d317de2517d11eb5b8c109.svg?v=2204207&p=247184"
            width={160}
            height={52}
            alt="Capterra"
          />
        </a>
      </Badge>
      <ListContainer>
        <ListItem>
          <Title>{t('review_title.0')}</Title>
          <RatingContainer>
            <Rating value={5.0} size="small" isReadOnly />
          </RatingContainer>
          <Description>{t('review_text.0')}</Description>
        </ListItem>
        <ListItem>
          <Title>{t('review_title.1')}</Title>
          <RatingContainer>
            <Rating value={4.0} size="small" isReadOnly />
          </RatingContainer>
          <Description>{t('review_text.1')}</Description>
        </ListItem>
        <ListItem>
          <Title>{t('review_title.2')}</Title>
          <RatingContainer>
            <Rating value={5.0} size="small" isReadOnly />
          </RatingContainer>
          <Description>{t('review_text.2')}</Description>
        </ListItem>
      </ListContainer>
      <More>
        <Button
          color="primary"
          size="large"
          href={webPath(signUpPath({ to: onboardPath() }), router.locale)}
        >
          {t('sign up')}
        </Button>
      </More>
    </>
  );
}
const ListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: ${spacing(16)};
  row-gap: ${spacing(16)};
  margin-bottom: ${spacing(32)};

  ${mediaMax.tablet} {
    grid-template-columns: 1fr;
  }
`;

const ListItem = styled.div`
  background-color: ${white};
  padding: ${spacing(32)} ${spacing(24)};
  border-radius: ${borderRadius(12)};
  ${mediaMax.tablet} {
    width: 100%;
  }
`;
const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(16)};
  margin-bottom: ${spacing(8)};
  text-align: center;
`;
const Description = styled.div``;

const More = styled.div`
  margin-top: ${spacing(32)};
  text-align: center;
`;

const Badge = styled.div`
  width: 160px;
  margin: 0 auto;
  margin-bottom: ${spacing(32)};
`;

const RatingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing(12)};
`;
